var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 13.2c-.3-.6-7-11.7-7.5-12.7C9-.1 8.1-.1 7.8.5 7.4 1.2.7 12.4.2 13.2c-.3.6 0 1.4.8 1.4h15c.7 0 1.3-.7.9-1.4zm-8.4.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm.6-3c0 .4-.2.6-.6.6s-.6-.2-.6-.6l-.6-5.6c0-.6.4-1.2 1.2-1.2s1.2.6 1.2 1.2l-.6 5.6z",
    fill: "#e3215f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPink);
export default __webpack_public_path__ + "static/media/alert-pink.beb3e6d8bb0c4cefa8e0f4969a464118.svg";
export { ForwardRef as ReactComponent };